module.exports = __webpack_public_path__ + "static/img/6.63a41b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/sp/6.png
// module id = BRdj
// module chunks = 0